/**
 * Animated wave layers — any <svg data-waves='{"width","height","layers":[…]}'>
 * with one <path> per layer. The first frame is rendered server-side
 * (inc/waves.php, same maths), so without JS or with reduced motion the waves
 * are still there. Animates only while the SVG is in view.
 */

const waveY = (x, l, t) => {
  const ph = l.seed + t * l.speed;
  return l.base + Math.sin((x / l.len) * Math.PI * 2 + ph) * l.amp
    + Math.sin((x / (l.len * 0.43)) * Math.PI * 2 - ph * 1.3) * l.amp * 0.25;
};

const wavePath = (w, h, l, t) => {
  let d = `M0 ${h}L0 ${waveY(0, l, t).toFixed(1)}`;
  for (let x = 24; x <= w + 24; x += 24) d += `L${x} ${waveY(x, l, t).toFixed(1)}`;
  return `${d}L${w + 24} ${h}Z`;
};

export function initWaves(root = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.querySelectorAll('svg[data-waves]').forEach((svg) => {
    let config;
    try {
      config = JSON.parse(svg.dataset.waves);
    } catch {
      return;
    }
    const paths = [...svg.querySelectorAll('path')];
    let raf = 0;
    let visible = false;
    let start = null; // t starts at 0 = the server-rendered frame (no jump)
    let paused = 0;   // time spent off-screen, so the motion resumes where it left off
    let hiddenAt = 0;

    const frame = (now) => {
      if (start === null) start = now;
      if (hiddenAt) { paused += now - hiddenAt; hiddenAt = 0; }
      const t = (now - start - paused) / 1000;
      config.layers.forEach((l, i) => paths[i]?.setAttribute('d', wavePath(config.width, config.height, l, t)));
      if (visible) {
        raf = requestAnimationFrame(frame);
      } else {
        raf = 0;
        hiddenAt = now;
      }
    };

    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible && !raf) raf = requestAnimationFrame(frame);
    }).observe(svg);
  });
}
